export default __webpack_public_path__ + "static/page-background-top-right-da768156262acf4ded733aae29e49ccc.png";